"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createStatusManager;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _utils = require("./utils");
function createStatusManager() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _p$config = p.config,
    config = _p$config === void 0 ? {} : _p$config;
  var statusField = "_status";
  var authorStatusField = "_author" + statusField;
  var _config$statuses = config.statuses,
    statuses = _config$statuses === void 0 ? {
      featured: 120,
      approved: 100,
      requiredData: 50,
      created: 40,
      deleted: 30,
      banned: 20
    } : _config$statuses,
    _config$requiredDataF = config.requiredDataForStatus,
    requiredDataForStatus = _config$requiredDataF === void 0 ? {} : _config$requiredDataF;

  //internal functions

  function recursiveDataTypeValidate() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var data = p.data,
      required = p.required;
    data = data && data.toObject ? data.toObject() : data;
    var valid = true;
    Object.keys(required).forEach(function (key) {
      if (required[key] && typeof required[key] === "object" && typeof required[key].type == "undefined" && typeof required[key].value == "undefined") {
        if (data[key] && typeof data[key] === "object") {
          valid = recursiveDataTypeValidate({
            data: data[key],
            required: required[key]
          });
        } else {
          valid = false;
        }
      } else {
        if (required[key]) {
          if (typeof required[key].type == "function" && required[key].type.name && required[key].type.name.toLowerCase() !== typeof data[key] || typeof required[key].type == "function" && required[key].type.name && required[key].type.name.toLowerCase() === "string" && data[key] === '' || typeof required[key].type == "function" && required[key].type.name && required[key].type.name.toLowerCase() === "object" && data[key] === null || typeof required[key].type == "function" && required[key].type.name && required[key].type.name.toLowerCase() === "array" && data[key] === [] || typeof required[key].value !== "undefined" && typeof required[key].value !== typeof data[key] || typeof required[key].value !== "undefined" && required[key].value !== data[key]) {
            valid = false;
          }
        }
      }
    });
    return valid;
  }
  function dynamicStatus(_ref) {
    var requiredData = _ref.requiredData;
    var newStatus;
    if (requiredData) {
      newStatus = statusManager.statuses["requiredData"];
    } else {
      newStatus = statusManager.statuses["created"];
    }
    return newStatus;
  }

  //exports

  function setNewStatus(doc) {
    var _doc$_author, _doc$_author2;
    var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
    var newStatus = currentStatus || statusManager.statuses["created"];
    if (currentStatus > statusManager.statuses["created"] - 1) {
      var requiredData = recursiveDataTypeValidate({
        data: doc,
        required: statusManager.requiredDataForStatus
      });
      newStatus = dynamicStatus({
        requiredData: requiredData
      });
    }
    doc[statusField] = newStatus;
    if (doc._id && (_doc$_author = doc._author) !== null && _doc$_author !== void 0 && _doc$_author._id && doc._id.toString() === doc._author._id.toString() || doc._id && !((_doc$_author2 = doc._author) !== null && _doc$_author2 !== void 0 && _doc$_author2._id) && doc._id.toString() === doc._author.toString()) {
      doc[authorStatusField] = newStatus;
    }
    return newStatus;
  }
  function setRestoreStatusByAdmin(doc) {
    var _doc$_author3, _doc$_author4;
    var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
    var newStatus = currentStatus || statusManager.statuses["created"];
    if (currentStatus < statusManager.statuses["deleted"]) {
      var requiredData = recursiveDataTypeValidate({
        data: doc,
        required: statusManager.requiredDataForStatus
      });
      newStatus = dynamicStatus({
        requiredData: requiredData
      });
    }
    doc[statusField] = newStatus;
    if (doc._id && (_doc$_author3 = doc._author) !== null && _doc$_author3 !== void 0 && _doc$_author3._id && doc._id.toString() === doc._author._id.toString() || doc._id && !((_doc$_author4 = doc._author) !== null && _doc$_author4 !== void 0 && _doc$_author4._id) && doc._id.toString() === doc._author.toString()) {
      doc[authorStatusField] = newStatus;
    }
    return newStatus;
  }
  function setRestoreStatusByAuthor(doc) {
    var _doc$_author5, _doc$_author6;
    var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
    var newStatus = currentStatus || statusManager.statuses["deleted"];
    if (currentStatus === statusManager.statuses["deleted"]) {
      var requiredData = recursiveDataTypeValidate({
        data: doc,
        required: statusManager.requiredDataForStatus
      });
      newStatus = dynamicStatus({
        requiredData: requiredData
      });
    }
    doc[statusField] = newStatus;
    if (doc._id && (_doc$_author5 = doc._author) !== null && _doc$_author5 !== void 0 && _doc$_author5._id && doc._id.toString() === doc._author._id.toString() || doc._id && !((_doc$_author6 = doc._author) !== null && _doc$_author6 !== void 0 && _doc$_author6._id) && doc._id.toString() === doc._author.toString()) {
      doc[authorStatusField] = newStatus;
    }
    return newStatus;
  }
  function setDeletedStatus(doc) {
    var _doc$_author7, _doc$_author8;
    var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
    var newStatus = currentStatus || statusManager.statuses["deleted"];
    var featuredStatus = getFeaturedStatus();
    if (currentStatus > statusManager.statuses["deleted"] && currentStatus < featuredStatus) {
      newStatus = statusManager.statuses["deleted"];
    }
    doc[statusField] = newStatus;
    if (doc._id && (_doc$_author7 = doc._author) !== null && _doc$_author7 !== void 0 && _doc$_author7._id && doc._id.toString() === doc._author._id.toString() || doc._id && !((_doc$_author8 = doc._author) !== null && _doc$_author8 !== void 0 && _doc$_author8._id) && doc._id.toString() === doc._author.toString()) {
      doc[authorStatusField] = newStatus;
    }
    return newStatus;
  }
  function setBanStatus(doc) {
    var _doc$_author9, _doc$_author0;
    var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
    var newStatus = currentStatus || statusManager.statuses["created"];
    var featuredStatus = getFeaturedStatus();
    if (currentStatus > statusManager.statuses["banned"] && currentStatus < featuredStatus) {
      newStatus = statusManager.statuses["banned"];
    }
    doc[statusField] = newStatus;
    if (doc._id && (_doc$_author9 = doc._author) !== null && _doc$_author9 !== void 0 && _doc$_author9._id && doc._id.toString() === doc._author._id.toString() || doc._id && !((_doc$_author0 = doc._author) !== null && _doc$_author0 !== void 0 && _doc$_author0._id) && doc._id.toString() === doc._author.toString()) {
      doc[authorStatusField] = newStatus;
    }
    return newStatus;
  }
  function setApproveStatus(doc) {
    var _doc$_author1, _doc$_author10;
    var getMinStatus = statusManager.getMinStatus;
    var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
    var newStatus = currentStatus || statusManager.statuses["created"];
    var minEnableApproveStatus = getMinStatus();
    var maxEnableApproveStatus = getFeaturedStatus();
    if (currentStatus > minEnableApproveStatus - 1 && currentStatus < maxEnableApproveStatus) {
      newStatus = statusManager.statuses["approved"];
    }
    doc[statusField] = newStatus;
    if (doc._id && (_doc$_author1 = doc._author) !== null && _doc$_author1 !== void 0 && _doc$_author1._id && doc._id.toString() === doc._author._id.toString() || doc._id && !((_doc$_author10 = doc._author) !== null && _doc$_author10 !== void 0 && _doc$_author10._id) && doc._id.toString() === doc._author.toString()) {
      doc[authorStatusField] = newStatus;
    }
    return newStatus;
  }
  function setFeaturedStatus(doc) {
    var _doc$_author11, _doc$_author12;
    var getMinStatus = statusManager.getMinStatus;
    var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
    var newStatus = currentStatus || statusManager.statuses["created"];
    var minEnableFeaturedStatus = getMinStatus();
    if (currentStatus > minEnableFeaturedStatus - 1) {
      newStatus = statusManager.statuses["featured"];
    }
    doc[statusField] = newStatus;
    if (doc._id && (_doc$_author11 = doc._author) !== null && _doc$_author11 !== void 0 && _doc$_author11._id && doc._id.toString() === doc._author._id.toString() || doc._id && !((_doc$_author12 = doc._author) !== null && _doc$_author12 !== void 0 && _doc$_author12._id) && doc._id.toString() === doc._author.toString()) {
      doc[authorStatusField] = newStatus;
    }
    return newStatus;
  }
  function removeFeaturedStatus(doc) {
    var _doc$_author13, _doc$_author14;
    var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
    var newStatus = currentStatus || statusManager.statuses["created"];
    if (currentStatus === getFeaturedStatus()) {
      newStatus = statusManager.statuses["approved"];
    }
    doc[statusField] = newStatus;
    if (doc._id && (_doc$_author13 = doc._author) !== null && _doc$_author13 !== void 0 && _doc$_author13._id && doc._id.toString() === doc._author._id.toString() || doc._id && !((_doc$_author14 = doc._author) !== null && _doc$_author14 !== void 0 && _doc$_author14._id) && doc._id.toString() === doc._author.toString()) {
      doc[authorStatusField] = newStatus;
    }
    return newStatus;
  }
  function isFeatured(doc) {
    if (doc && doc._id) {
      var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
      if (currentStatus >= statusManager.statuses["featured"]) {
        return true;
      }
    }
    return false;
  }
  function isApproved(doc) {
    if (doc && doc._id) {
      var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
      if (currentStatus >= statusManager.statuses["approved"]) {
        return true;
      }
    }
    return false;
  }
  function isDeleted(doc) {
    if (doc && doc._id) {
      var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
      if (currentStatus === statusManager.statuses["deleted"]) {
        return true;
      }
    }
    return false;
  }
  function isBanned(doc) {
    if (doc && doc._id) {
      var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
      if (currentStatus < statusManager.statuses["deleted"]) {
        return true;
      }
    }
    return false;
  }
  function isNotDeleted(doc) {
    if (doc && doc._id) {
      var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
      if (currentStatus >= statusManager.statuses["created"]) {
        return true;
      }
    }
    return false;
  }
  function isValidated(doc) {
    if (doc && doc._id) {
      var currentStatus = doc[statusField] && !isNaN(Number(doc[statusField])) ? Number(doc[statusField]) : 0;
      if (currentStatus >= statusManager.statuses["requiredData"]) {
        return true;
      }
    }
    return false;
  }
  function getDefaultStatus() {
    return statusManager.statuses["created"];
  }
  function getMinStatus() {
    return statusManager.statuses["requiredData"];
  }
  function getFeaturedStatus() {
    return statusManager.statuses["featured"];
  }
  function getBannedStatus() {
    return statusManager.statuses["banned"];
  }
  function getDeletedStatus() {
    return statusManager.statuses["deleted"];
  }
  var statusManager = Object.create(Object.prototype, {
    statuses: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: statuses
    }),
    statusField: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: statusField
    }),
    authorStatusField: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: authorStatusField
    }),
    _status_isBanned: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: statusField + "_isBanned"
    }),
    _status_isDeleted: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: statusField + "_isDeleted"
    }),
    _status_isNotDeleted: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: statusField + "_isNotDeleted"
    }),
    _status_isValidated: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: statusField + "_isValidated"
    }),
    _status_isApproved: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: statusField + "_isApproved"
    }),
    _status_isFeatured: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: statusField + "_isFeatured"
    }),
    _author_status_isNotDeleted: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: authorStatusField + "_isNotDeleted"
    }),
    requiredDataForStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      enumerable: false,
      value: requiredDataForStatus
    }),
    setNewStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: setNewStatus
    }),
    setRestoreStatusByAdmin: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: setRestoreStatusByAdmin
    }),
    setRestoreStatusByAuthor: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: setRestoreStatusByAuthor
    }),
    setDeletedStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: setDeletedStatus
    }),
    setBanStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: setBanStatus
    }),
    setApproveStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: setApproveStatus
    }),
    setFeaturedStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: setFeaturedStatus
    }),
    removeFeaturedStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: removeFeaturedStatus
    }),
    isFeatured: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: isFeatured
    }),
    isApproved: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: isApproved
    }),
    isNotDeleted: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: isNotDeleted
    }),
    isValidated: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: isValidated
    }),
    isDeleted: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: isDeleted
    }),
    isBanned: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: isBanned
    }),
    getDefaultStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: getDefaultStatus
    }),
    getMinStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: getMinStatus
    }),
    getFeaturedStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: getFeaturedStatus
    }),
    getBannedStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: getBannedStatus
    }),
    getDeletedStatus: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: getDeletedStatus
    })
  });
  return statusManager;
}